import {createRouter, createWebHashHistory} from 'vue-router'
import Login from "../components/login/Login";
import miniAppServer from "../views/miniAppServer/miniAppServer";
import userManageServer from "../views/userManageServer/userManageServer";


const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login,
        meta: {
            title: "登录"
        }
    },
    {
        path: '/serviceIndex',
        name: 'miniAppServer',
        meta: {
            requireAuth: true
        },
        component: miniAppServer
    },
    {
        path: '/userManage',
        name: 'userManageServer',
        meta: {
            requireAuth: true
        },
        component: userManageServer
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
